export default "__VITE_ASSET__C07rFcOP__"